import QRCode from 'qrcode.react'

const QR = ({ value = 'https://google.com', ...props }) => <QRCode value={value} {...props} />

export default QR
